import React from 'react'
/**
 * A loading placeholder for the Commercial Services Card.
 * This component displays a grey placeholder box while the actual content is loading.
 * 
 * @component
 * @memberof Components
 * 
 * @returns {JSX.Element} A loading skeleton for the Commercial Services Card.
 */
const CommercialServicesCardLoading = () => {

    return (
        <div style={{ backgroundColor: 'lightgrey', width: '100%', height: '300px', borderRadius: '10px' }}>
        </div >
    )
}

export default CommercialServicesCardLoading